<script>
	import { Router, Link, link , Route } from "svelte-routing";
	import { linkConheca, mailAtendimento, textTelefone, linkTelefone, textWhatsapp, linkWhatsapp, linkAV, alt } from './store.js';	

	// Componentes
	import HeaderLanding 		from "./components/HeaderLanding.svelte";
	import Footer 				from "./components/Footer.svelte";
	import BoletoFacil 			from "./components/BoletoFacil.svelte";
	import Aviso 				from "./components/Aviso.svelte";
	
	// Rotas
	import Home 				from "./routes/Home.svelte";	
	import Obrigado 			from "./routes/Obrigado.svelte";	
	import Oops 				from "./routes/Oops.svelte";
	import PoliticaPrivacidade	from "./routes/PoliticaPrivacidade.svelte";

	// Code
	export let url = "";

    let menu = [
		{
			title: 'Empresa',
			icon: '<i class="fas fa-building"></i>',
			href: '/#atendimento',
		},
		{
			title: 'Serviços',
			icon: '<i class="fas fa-briefcase"></i>',
			href: '/#servicos',
		},
		{
			title: 'Diferenciais',
			icon: '<i class="fas fa-award"></i>',
			href: '/#diferenciais',
		},
		{
			title: 'Contato',
			icon: '<i class="fas fa-headset"></i>',
			href: '/#contato',
		},
	];

	let menuSecondary = [
		{
			title: 	$textWhatsapp,
			icon: 	'<i class="fab fa-whatsapp"></i>',
			href: 	$linkWhatsapp,
			target: '_blank',
		},
		{
			title: 	$textTelefone,
			icon: 	'<i class="fas fa-phone-alt"></i>',
			href: 	$linkTelefone,
			target: '_blank',
		},
		{
			title: 	'Área do Cliente',
			icon: 	'<i class="fas fa-barcode-alt"></i>',
			href: 	$linkAV,
			target: '_blank',
			classe: 'btn btn-primary',
		},
	];
</script>

<HeaderLanding menu={menu} menuSecondary={menuSecondary} logo="/images/logo.png"/>

<main>
	<Router url="{url}">
		<div class="routes">
			<Route path="/"><Home /></Route>
			<Route path="obrigado"><Obrigado /></Route>
			<Route path="oops"><Oops /></Route>
			<Route path="politica-de-privacidade"><PoliticaPrivacidade /></Route>
			<Route path="privacidade"><PoliticaPrivacidade /></Route>
		</div>
	</Router>
</main>

<Footer/>
<BoletoFacil />
<Aviso />